@if (platformBrowser) {
  <div class="page">
    @if (showEditBanner) {
      <div class="edit-public-tenant-header">
        <app-svg src="/assets/icons/globe-eye.svg"></app-svg>
        <span>You’re viewing your profile</span>
        <a
          [href]="config.correctPicflowUrl + '/a/settings/public-profile'"
          target="_blank"
          appButton
          name="edit"
          location="tenant-profile-page"
          color="primary"
          shape="round"
          height="0"
          size="1"
        >
          Edit Profile
        </a>
        <button
          (click)="showEditBanner = false"
          appButton
          name="close"
          location="tenant-profile-page"
          [iconButton]="true"
          color="simple"
          shape="round"
          height="0"
          class="close-button"
        >
          <app-svg src="/assets/icons/cross.svg"></app-svg>
        </button>
      </div>
    }

    <app-tenant-logo-and-contacts [tenant]="tenant"></app-tenant-logo-and-contacts>
    <div class="galleries-container">
      @if (galleries.length) {
        <div class="galleries">
          @for (gallery of galleries; track gallery) {
            <a [routerLink]="[gallery.path]" target="_blank">
              <app-gallery-item
                [gallery]="gallery"
                [publicMode]="true"
                [showPasswordProtected]="true"
              ></app-gallery-item>
            </a>
          }
        </div>
      }
    </div>
    @if (!galleries.length) {
      <div class="no-galleries" [class.with-logo]="tenant.logo_url">
        <span>There are no galleries to show.</span>
      </div>
    }
    @if (tenant.picflow_branding_enabled) {
      <app-made-with-picflow-button [tenantId]="tenant.id"> </app-made-with-picflow-button>
    }
  </div>
}
@if (!platformBrowser) {
  <div class="page center tiny loading">
    <app-tenant-icon-loader [tenant]="tenant"></app-tenant-icon-loader>
  </div>
}
